import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { PhysiologicalResult } from '../../model';
import type { StrengthAssessmentResultDataFragment } from '@/pages/PhysicalResultPage/Strength/Create/CreateStrengthAssessmentResult.api';
import { formatSecondsAsMinSec } from '@/utils/common';

const parseStrength = (t: TFunction, items: AssessmentResultItemDataFragment[]): PhysiologicalResult | null => {
    const item = items.find(i => i.result.__typename === 'StrengthResult');
    const mi = item?.moduleInstance;
    const r = item?.result as StrengthAssessmentResultDataFragment;
    if (!mi?.name || !r) {
        return null;
    }

    return {
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        name: mi.name ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.squatRepMaxKg'),
                value: r.squatRepMaxKg != null ? Number(r.squatRepMaxKg).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.deadliftRepMaxKg'),
                value: r.deadliftRepMaxKg != null ? Number(r.deadliftRepMaxKg).toFixed(2) : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.maxPullUps'),
                value: r.maxPullUps != null ? r.maxPullUps : t('traineeReports:na'),
            },
            {
                label: t('traineeReports:performance.physiologicalFitness.strength.sprintDragCarrySec'),
                value:
                    r.sprintDragCarrySec != null
                        ? (formatSecondsAsMinSec(r.sprintDragCarrySec) ?? t('traineeReports:na'))
                        : t('traineeReports:na'),
            },
        ],
    };
};

export default parseStrength;
